/**
 * GET系のAPIローディング状態の型定義。
 */
export type ApiGetLoadStatusType = "success" | "error" | "loading" | "beforeRequest";

/**
 * GET系のAPIローディング状態の型定義が持ち得る値一覧。
 */
export const ApiGetLoadStatus = {
	/**
	 * APIリクエストが成功した状態。
	 */
	success: "success" as ApiGetLoadStatusType,
	/**
	 * APIリクエストが失敗した状態。
	 */
	error: "error" as ApiGetLoadStatusType,
	/**
	 * APIリクエストがロード中の時の状態。
	 */
	loading: "loading" as ApiGetLoadStatusType,
	/**
	 * APIリクエスト送付前の状態。
	 */
	beforeRequest: "beforeRequest" as ApiGetLoadStatusType,
};

/**
 * GET系の追加読み込み分のAPIローディング状態の型定義。
 */
export type ApiGetLoadAddStatusType = "success" | "error" | "loading" | "beforeRequest" | "addLoading" | "addError";
/**
 * GET系の追加読み込み分のAPIローディング状態の型定義が持ち得る値一覧。
 */
export const ApiGetLoadAddStatus = {
	/**
	 * APIリクエストが成功した状態。
	 */
	success: "success" as ApiGetLoadStatusType,
	/**
	 * APIリクエストが失敗した状態。
	 */
	error: "error" as ApiGetLoadAddStatusType,
	/**
	 * APIリクエストがロード中の時の状態。
	 */
	loading: "loading" as ApiGetLoadAddStatusType,
	/**
	 * APIリクエスト送付前の状態。
	 */
	beforeRequest: "beforeRequest" as ApiGetLoadAddStatusType,
	/**
	 * API追加読み込みリクエストがロード中の時の状態。
	 */
	addLoading: "addLoading" as ApiGetLoadAddStatusType,
	/**
	 * API追加読み込みリクエストが失敗した状態。
	 */
	addError: "addError" as ApiGetLoadAddStatusType,
};

/**
 * POST系のAPIローディング状態の型定義。
 */
export type ApiPostLoadStatusType = "success" | "error" | "loading" | "beforeRequest";

/**
 * POST系のAPIローディング状態の型定義が持ち得る値一覧。
 */
export const ApiPostLoadStatus = {
	/**
	 * APIリクエストが成功した状態。
	 */
	success: "success" as ApiPostLoadStatusType,
	/**
	 * APIリクエストが失敗した状態。
	 */
	error: "error" as ApiPostLoadStatusType,
	/**
	 * APIリクエストがロード中の時の状態。
	 */
	loading: "loading" as ApiPostLoadStatusType,
	/**
	 * APIリクエスト送付前の状態。
	 */
	beforeRequest: "beforeRequest" as ApiPostLoadStatusType,
};
